import { render, staticRenderFns } from "./learnerHistory.vue?vue&type=template&id=332f0d62&"
import script from "./learnerHistory.vue?vue&type=script&lang=js&"
export * from "./learnerHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports